import { Controller } from "@hotwired/stimulus"

// Drives the topbar's fullscreen and dark/light theme toggle buttons.
// Theme preference persists in localStorage and is applied by setting
// data-bs-theme on <html>, which the GotPOS theme CSS already styles
// (including swapping .logo-dark/.logo-light).
export default class extends Controller {
  static targets = [
    "fullscreenOpenIcon", "fullscreenCloseIcon",
    "themeDarkIcon", "themeLightIcon"
  ]

  connect() {
    this.theme = localStorage.getItem("stoela-theme") || "light"
    this.applyTheme()

    this.fullscreenHandler = this.handleFullscreenChange.bind(this)
    document.addEventListener("fullscreenchange", this.fullscreenHandler)
  }

  disconnect() {
    document.removeEventListener("fullscreenchange", this.fullscreenHandler)
  }

  toggleFullscreen() {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen()
    } else {
      document.exitFullscreen()
    }
  }

  handleFullscreenChange() {
    const isFullscreen = !!document.fullscreenElement
    this.fullscreenOpenIconTarget.classList.toggle("d-none", isFullscreen)
    this.fullscreenCloseIconTarget.classList.toggle("d-none", !isFullscreen)
  }

  toggleTheme() {
    this.theme = this.theme === "dark" ? "light" : "dark"
    localStorage.setItem("stoela-theme", this.theme)
    this.applyTheme()
  }

  applyTheme() {
    document.documentElement.setAttribute("data-bs-theme", this.theme)
    this.themeDarkIconTarget.classList.toggle("d-none", this.theme === "dark")
    this.themeLightIconTarget.classList.toggle("d-none", this.theme !== "dark")
  }
}
